import { LanguageKey, LocalesSystemTypes } from 'services/systems/types';
import {
  ACConstantRoutesCodes,
  AC_CONSTANT_ROUTE,
  AC_CONSTANT_ROUTE_EN,
  ConstantExternalRoutesCodes,
  ConstantRoutesCodes,
  CONSTANT_EXTERNAL_ROUTE,
  CONSTANT_EXTERNAL_ROUTE_EN,
  CONSTANT_ROUTE,
  CONSTANT_ROUTE_EN,
} from 'utils/constants';

export const langLabel = (key: string, currentlang: string) => {
  switch (key) {
    case 'vi':
      return currentlang === 'vi' ? 'Tiếng Việt' : 'Vietnamese';
    case 'en':
      return currentlang === 'vi' ? 'Tiếng Anh' : 'English';
    default:
      return '';
  }
};

export const checkActiveLang = (
  activeLang: LanguageKey,
  listActive?: LocalesSystemTypes,
): boolean => {
  if (listActive && activeLang) {
    return !!listActive[activeLang].active;
  }
  return false;
};

export function getHomeLangURL(lang?: string) {
  if (lang && lang !== 'vi') return `/${lang}`;
  return '/';
}

export function getAcDashboardURL(lang?: string) {
  if (lang && lang !== 'vi') return `/${lang}${AC_CONSTANT_ROUTE_EN.DASHBOARD}`;
  return AC_CONSTANT_ROUTE.DASHBOARD;
}

export function getLangURL(lang?: string) {
  if (lang && lang !== 'vi') return `/${lang}`;
  return '';
}

export function getActiveLanguages(locales?: LocalesSystemTypes) {
  if (locales) {
    return (Object.keys(locales) as Array<LanguageKey>).reduce(
      (prev: Array<LanguageKey>, curr: LanguageKey) => (locales[curr].active
        ? [...prev, curr] : [...prev]),
      [],
    );
  }
  return [];
}

export function getStaticSlug(code: ConstantRoutesCodes, lang: string) {
  switch (lang) {
    case 'en':
      return `${CONSTANT_ROUTE_EN[code]}`;
    default:
      return `${CONSTANT_ROUTE[code]}`;
  }
}

export function getLangSlug(code: ConstantRoutesCodes, lang: string) {
  switch (lang) {
    case 'en':
      return `en/${CONSTANT_ROUTE_EN[code]}`;
    default:
      return `${CONSTANT_ROUTE[code]}`;
  }
}

export function getStaticACSlug(code: ACConstantRoutesCodes, lang: string) {
  switch (lang) {
    case 'en':
      return `${AC_CONSTANT_ROUTE_EN[code]}`;
    default:
      return `${AC_CONSTANT_ROUTE[code]}`;
  }
}

export function getStaticURL(code: ConstantRoutesCodes, lang: string, slug?: string) {
  switch (lang) {
    case 'en':
      return `/en/${CONSTANT_ROUTE_EN[code]}${slug ? `/${slug}` : ''}`;
    default:
      return `/${CONSTANT_ROUTE[code]}${slug ? `/${slug}` : ''}`;
  }
}

export function getStaticAcURL(code: ACConstantRoutesCodes, lang: string) {
  switch (lang) {
    case 'en':
      return `/en${AC_CONSTANT_ROUTE_EN[code]}`;
    default:
      return `${AC_CONSTANT_ROUTE[code]}`;
  }
}

export function getStaticExternalSlug(code: ConstantExternalRoutesCodes, lang: string) {
  switch (lang) {
    case 'en':
      return `${CONSTANT_EXTERNAL_ROUTE_EN[code]}`;
    default:
      return `${CONSTANT_EXTERNAL_ROUTE[code]}`;
  }
}

export function convertHomeRoute(langList: LanguageKey[]) {
  return langList.map((ele) => getHomeLangURL(ele));
}

export function convertRoute(langList: LanguageKey[], slug?: string) {
  return langList.map((ele) => `${getLangURL(ele)}${slug || ''}`);
}

export function convertStaticRoute(
  code: ConstantRoutesCodes,
  langList: LanguageKey[],
  noSubSlug?: boolean,
) {
  return langList.map(
    (ele) => `${getLangURL(ele)}/${getStaticSlug(code, ele)}${noSubSlug ? '' : '/:slug'}`,
  );
}

export function convertStaticACRoute(
  code: ACConstantRoutesCodes,
  langList: LanguageKey[],
  noSubSlug?: boolean,
) {
  return langList.map(
    (ele) => `${getLangURL(ele)}${getStaticACSlug(code, ele)}${noSubSlug ? '' : '/:slug'}`,
  );
}

export function convertStaticACPageTranslation(
  code: ACConstantRoutesCodes,
  langList: LanguageKey[],
  noSubSlug?: boolean,
  params?: string,
) {
  return langList.map((ele) => ({
    locale: ele,
    title: '',
    slug: `${getStaticACSlug(code, ele)}${noSubSlug ? '' : '/:slug'}${params || ''}`,
  }));
}

export function convertStaticPageTranslation(
  code: ConstantRoutesCodes,
  langList: LanguageKey[],
  noSubSlug?: boolean,
  params?: string,
) {
  return langList.map((ele) => ({
    locale: ele,
    title: '',
    slug: `${getStaticSlug(code, ele)}${noSubSlug ? '' : '/:slug'}${params || ''}`,
  }));
}

export const getSlugByTemplateCode = (
  templateCode: string,
  staticSlug?: StaticSlug[],
): string => {
  if (staticSlug) {
    const res = staticSlug.find((ele) => ele.templateCode === templateCode);
    if (res) return res.slug;
    return '';
  }
  return '';
};
